module.exports = __webpack_public_path__ + "img/18.c589dde9.jpg";